function enhancePopupAccessibility(popup) {
    // Save element focused before popup
    const previouslyFocused = document.activeElement;

    // Ensure popup can be focused
    if (!popup.hasAttribute('tabindex')) {
        popup.setAttribute('tabindex', '-1');
    }

    // Add ARIA label dynamically if missing
    if (!popup.hasAttribute('aria-label') && !popup.hasAttribute('aria-labelledby')) {
        let labelElement = popup.querySelector('h1, h2, h3, .lacenter-TextElement--content, p');
        if (labelElement) {
            let cleanText = labelElement.textContent.trim().replace(/\s+/g, ' ');
            popup.setAttribute('aria-label', cleanText);
        } else {
            popup.setAttribute('aria-label', 'Website popup');
        }
    }

    // Mark as modal
    popup.setAttribute('aria-modal', 'true');

    // Add label to close button
    const closeBtn = popup.querySelector('.CloseButton__ButtonElement-sc-79mh24-0');
    if (closeBtn && !closeBtn.hasAttribute('aria-label')) {
        closeBtn.setAttribute('aria-label', 'Close popup');
    }

    // Focus the popup itself (not an input)
    popup.focus();

    // Trap focus inside popup
    const focusableSelectors = 'a[href], button, textarea, input, select, [tabindex]:not([tabindex="-1"])';
    const focusableElements = Array.from(popup.querySelectorAll(focusableSelectors));

    function trapFocus(e) {
        if (e.key === 'Tab') {
            if (focusableElements.length === 0) {
                e.preventDefault();
                return;
            }
            const firstEl = focusableElements[0];
            const lastEl = focusableElements[focusableElements.length - 1];

            if (e.shiftKey) {
                // Shift + Tab
                if (document.activeElement === firstEl) {
                    e.preventDefault();
                    lastEl.focus();
                }
            } else {
                // Tab
                if (document.activeElement === lastEl) {
                    e.preventDefault();
                    firstEl.focus();
                }
            }
        }
    }

    popup.addEventListener('keydown', trapFocus);

    // Close on Escape
    function escHandler(e) {
        if (e.key === 'Escape') {
            closeBtn?.click();
            document.removeEventListener('keydown', escHandler);
            popup.removeEventListener('keydown', trapFocus);

            // Restore previous focus
            if (previouslyFocused && previouslyFocused.focus) {
                previouslyFocused.focus();
            }
        }
    }
    document.addEventListener('keydown', escHandler);
}

document.addEventListener('DOMContentLoaded', function () {
    // Immediate check
    const existingPopup = document.querySelector('[role="dialog"]');
    if (existingPopup) {
        enhancePopupAccessibility(existingPopup);
    }

    // Watch for delayed popup
    const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
            mutation.addedNodes.forEach(node => {
                if (node.nodeType === 1 && node.matches?.('[role="dialog"]')) {
                    enhancePopupAccessibility(node);
                }
                if (node.nodeType === 1) {
                    const popupInside = node.querySelector?.('[role="dialog"]');
                    if (popupInside) {
                        enhancePopupAccessibility(popupInside);
                    }
                }
            });
        });
    });

    observer.observe(document.body, { childList: true, subtree: true });
});